import React, { useEffect } from 'react';
import './psatencionpam.css';
import { psatencionpam } from '../../json/psatencionpam';

const Psatencionpam = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className='container container-mh'>
      <div className='row'>
        <div className='col-12'>
          <h3 className='title'>Programa Atención a las Personas Adultas Mayores</h3>
          <hr className='hr-gob' />
        </div>
      </div>

      <div className='row'>
        <div className='col-12 container-armon'>
          <div className='armo-collapse'>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
             
              <div style={{ textAlign: 'left' }}>
                <h5 style={{ fontWeight: 'bold' }}>Descripción del Programa</h5>
                <p>
              
                </p>
                <h6 className='description' style={{ marginTop: '20px' }}>
                Que el Programa de Atención a Personas Adultas Mayores, tiene como objeto atender las necesidades y demandas de las personas mayores en el Estado de Hidalgo, con la expectativa de favorecer el bienestar biopsicosocial en la vejez e incrementar la calidad de vida durante el proceso de envejecimiento, a través de la implementación de la atención centrada en la persona y servicios gerontológicos orientados al fomento del envejecimiento digno, positivo y exitoso; así como, a la investigación y enseñanza en gerontología. El Modelo Hidalgo de Atención Gerontológica está compuesto por los principios de Dignidad, Independencia, Autocuidado, Participación, Autonomía, Integralidad, Bienestar y Protección Social, encaminados a dar cumplimiento a los derechos humanos de las personas mayores, dicho esquema de atención está estructurado con acciones y estrategias dirigidas a prevenir la fragilidad y vulnerabilidad, fomentar el mantenimiento de la salud, propiciar la reintegración social, prolongar la funcionalidad y mejorar las condiciones de vida.
                </h6><br />
                <h5 style={{ fontWeight: 'bold' }}>Objetivo del Programa</h5>
                <p>
                Brindar atención integral y ambulatoria a las Personas Adultas Mayores mediante acciones gerontológicas para mejorar su bienestar.
                </p>
                <h5 style={{ fontWeight: 'bold' }}>Población Objetivo</h5>
                <p>
                El 7.6% (24,010) de las personas mayores que radiquen, estén domiciliadas o en tránsito en el Estado de Hidalgo.
                </p>
                <h5 style={{ fontWeight: 'bold' }}>Cobertura</h5>
                <p>
                La cobertura de los apoyos y acciones gerontológicas operará a nivel estatal, en la capacidad que permita la infraestructura y presupuesto del programa.
                </p>
                <h5 style={{ fontWeight: 'bold' }}>Vigencia</h5>
                <p>
                Anual
                </p>
                <h5 style={{ fontWeight: 'bold' }}>Áreas de atención</h5>
                <p>
                  
                  <ul>
                  <li>Secretaría de Bienestar en Inclusión Social<br />                    
                  </li>
                  <li>Dirección General del <a
                href='https://adultosmayores.hidalgo.gob.mx/'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Instituto de las y los Adultos Mayores del Estado de Hidalgo</a>
                  </li>
                  </ul></p>
                <h5 style={{ fontWeight: 'bold' }}>Personas Responsables del Programa</h5>
                <p>
                  
                  <ul>
                  <li>Lic. Ariadna Penélope Apodaca Sinsel<br />                    
                  </li>
                  </ul></p>
                <h5 style={{ fontWeight: 'bold' }}>Teléfono de Contacto</h5>
                <p>
                
                (771) 71 9-33-68<br />
                (771) 37-6-90-41<br />
                (771) 37-6-90-42                       

                </p>
                <h5 style={{ fontWeight: 'bold' }}><strong><a
                href='/Transparencia/pdfs/ROPs/ROP´S_Adultos_2023.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Reglas de Operación</a></strong></h5>
                <p>
                </p>
                
                <p>
                </p>
              </div>
            </div>
            
          </div>
        </div>
      </div>    
    </div>
  );
};

export default Psatencionpam;